import { render } from "./AnonymousPageBar.vue?vue&type=template&id=31c102de"
import script from "./AnonymousPageBar.vue?vue&type=script&lang=js"
export * from "./AnonymousPageBar.vue?vue&type=script&lang=js"

import "./AnonymousPageBar.vue?vue&type=style&index=0&id=31c102de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__